import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ReactGA from "react-ga4";
import { ToastContainer } from "react-toastify";

// Components
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTopButton from "./components/Button/ScrollToTopButton";
import MobileNavbar from "./components/MobileNavbar/MobileNavbar";

// Pages
import Home from "./pages/Home/Home";
import MoviePhim from "./pages/DetailMovie/DetailMovie";
import WatchPage from "./pages/WatchPage/WatchPage";
import Profile from "./pages/UserPage/Profile";
import UserLayout from "./layouts/UserLayout/UserLayout";
import FavoriteMovies from "./pages/UserPage/FavoriteMovies";
import ContinueWatching from "./pages/UserPage/ContinueWatching";
import AdminLayout from "./layouts/AdminLayout/AdminLayout";
import AddPhim from "./pages/AdminPage/Addphim";
import CategoryMovies from "./pages/CategoryMovie/CategoryMovie";
import CountryMovie from "./pages/CountryMovie/CountryMovie";
import SearchMovies from "./pages/SearchMovie.jsx/SearchMovie";
import NotFound from "./pages/404/NotFound";
import TopicMovie from "./pages/TopicMovie/TopicMovie";
ReactGA.initialize("G-T9106NDWVY");

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
};

// Google Analytics page tracking
const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
  return null;
};

// Wrapper to add animation to each page (trừ trang chủ)
const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -100 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <>
              <Home />
            </>
          }
        />
        <Route
          path="/phim/:slug"
          element={
            <PageWrapper>
              <MoviePhim />
            </PageWrapper>
          }
        />
        <Route
          path="/xem-phim/:slug/tap/:tapId"
          element={
            <PageWrapper>
              <WatchPage />
            </PageWrapper>
          }
        />

        <Route path="/user" element={<UserLayout />}>
          <Route
            path="profile"
            element={
              <PageWrapper>
                <Profile />
              </PageWrapper>
            }
          />
          <Route
            path="favorites"
            element={
              <PageWrapper>
                <FavoriteMovies />
              </PageWrapper>
            }
          />
          <Route
            path="continue-watching"
            element={
              <PageWrapper>
                <ContinueWatching />
              </PageWrapper>
            }
          />
        </Route>
        <Route path="/admin" element={<AdminLayout />}>
          <Route
            path="addphim"
            element={
              <PageWrapper>
                <AddPhim />
              </PageWrapper>
            }
          />
        </Route>
        <Route
          path="/the-loai/:slug/:ten"
          element={
            <PageWrapper>
              <CategoryMovies />
            </PageWrapper>
          }
        />
        <Route
          path="/phim/loaiphim/:loai_phim"
          element={
            <PageWrapper>
              <CategoryMovies />
            </PageWrapper>
          }
        />
        <Route
          path="/topic/:name"
          element={
            <PageWrapper>
              <TopicMovie />
            </PageWrapper>
          }
        />

        <Route
          path="/topic"
          element={
            <PageWrapper>
              <TopicMovie />
            </PageWrapper>
          }
        />

        <Route
          path="/quoc-gia/:code/:name"
          element={
            <PageWrapper>
              <CountryMovie />
            </PageWrapper>
          }
        />
        <Route
          path="/search"
          element={
            <PageWrapper>
              <SearchMovies />
            </PageWrapper>
          }
        />
        <Route
          path="*"
          element={
            <PageWrapper>
              <NotFound />
            </PageWrapper>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <PageViewTracker />
      <ScrollToTop />
      <div className="flex flex-col min-h-[100vh]">
        <Header />
        <main className="flex-1">
          <AnimatedRoutes />
        </main>
        <ScrollToTopButton />
        <Footer />
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={1500}
        theme="light"
        toastStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          color: "#fff",
          backdropFilter: "blur(5px)",
          fontFamily: "'Quicksand', sans-serif",
          fontSize: "14px",
          height: "10px",
        }}
      />
    </Router>
  );
};

export default App;
